import React, { Component } from 'react';
import getUserDetail from 'actions/get-user-detail';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import Loader from '../common/components/loader';
import { history } from 'routes';

class PrivateRoute extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
    };
  }

  async componentDidMount() {
    !this.props.userDetail && (await this.props.getUserDetail());
    // this.initialize();
  }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.userDetail !== this.props.userDetail) {
  //     if (this.props.userDetail) {
  //       this.initialize();
  //     }
  //   }
  // }

  initialize = () => {
    const { userDetail } = this.props;

    if (userDetail) {
      // if (!userDetail.productInfoRead) {
      //   return history.push('/');
      // } else if (!userDetail.termsAccepted) {
      //   return history.push('/terms-conditions');
      // }
    }
  };

  render() {
    const { userDetail, isLoading } = this.props;

    return (
      <>
        {isLoading && <Loader />}
        {userDetail && <Route {...this.props} />}
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...state.loginReducer,
});

const mapDispatchToProps = dispatch => ({
  getUserDetail: () => dispatch(getUserDetail()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
